import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';

const api = new APICore();
const Branch = apiContainer.Branch;

// GET all branches with optional filters
export async function getBranchesApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Branch}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

// GET single branch by ID
export async function getBranchByIdApi(branchId) {
    try {
        return api.get(`${Branch}/${branchId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

// CREATE new branch
export async function createBranchApi(request) {
    try {
        return api.create(`${Branch}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

// UPDATE branch by ID
export async function updateBranchApi(request, branchId) {
    try {
        return api.update(`${Branch}/${branchId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

// DELETE branch by ID
export async function deleteBranchApi(branchId) {
    try {
        return api.delete(`${Branch}/${branchId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}